import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CTA_PRINCIPAL, PRECIO, PRECIO_ANTERIOR, bonos } from '../data/content';
export function OfferSection() {
  return <section id="comprar" className="w-full scroll-mt-4 bg-navy py-11 text-white sm:py-14 lg:py-16" data-id="element-122" data-mp="8mdn7ej0fl4o">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 items-center gap-6 px-5 sm:px-8 lg:grid-cols-[1fr_0.9fr] lg:gap-12" data-id="element-123" data-mp="dfq04rebu3hl">
        <div data-id="element-124" data-mp="metkdyp8coxo">
          <h2 className="font-display text-2xl font-extrabold leading-[1.12] tracking-tight sm:text-4xl" data-id="element-125" data-mp="mejueb46qhrz">
            Todo lo que se lleva tu compra
          </h2>
          <ul className="mt-4 space-y-2" data-id="element-126" data-mp="rbtqg9m2xros">
            <li className="flex items-start gap-2.5 text-[15px] text-white/90" data-id="element-127" data-mp="wdj3tvwryhg1">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste" aria-hidden="true" data-id="element-128" data-mp="2t59ldip79spk" />
              Manual SOS VERAZ — Protocolo de Salida Rápida (6 etapas)
            </li>
            {bonos.map(bono => <li key={bono.title} className="flex items-start gap-2.5 text-[15px] text-white/90" data-id="element-129" data-mp="12o1rms1ygi2r">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-oro" aria-hidden="true" data-id="element-130" data-mp="xwa5ctpu0yif" />
                {bono.title}
              </li>)}
          </ul>
        </div>

        {/* Ficha de compra */}
        <div className="rounded-2xl bg-white p-5 text-navy sm:p-7" data-id="element-131" data-mp="ox52jb78mj0g">
          <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-navy-muted" data-id="element-132" data-mp="1lm4bytjk5qu8">
            Acceso digital inmediato
          </p>
          <h3 className="mt-2 font-display text-xl font-extrabold uppercase leading-tight tracking-tight" data-id="element-133" data-mp="1gnt2wl137kd2">
            SOS Veraz
          </h3>
          <p className="text-sm font-semibold text-navy-soft" data-id="element-134" data-mp="17mv9ewo9yv8q">Protocolo de Salida Rápida</p>

          <div className="mt-4 border-y border-dashed border-navy/25 py-4" data-id="element-135" data-mp="16j9aq1w73ai">
            <p className="font-mono text-sm text-navy-muted line-through" data-id="element-136" data-mp="14g6t6jjzhow">{PRECIO_ANTERIOR}</p>
            <div className="mt-1 flex items-baseline gap-2" data-id="element-137" data-mp="3sbj1w92ii84e">
              <span className="font-mono text-sm font-bold text-navy-muted" data-id="element-138" data-mp="3tv13keiyz36g">ARS</span>
              <span className="font-display text-[2.75rem] font-extrabold leading-none tracking-tight sm:text-6xl" data-id="element-139" data-mp="2o8177cfwy0c">
                {PRECIO}
              </span>
            </div>
            <p className="mt-2 text-sm font-semibold text-navy-soft" data-id="element-140" data-mp="3ouwomsxpmgic">
              Pago único · Manual + 3 bonos
            </p>
          </div>

          <CtaButton label={CTA_PRINCIPAL} className="mt-4" data-id="element-141" data-mp="3b2q835qna7id" />

          <p className="mt-3 flex items-center justify-center gap-2 text-center text-xs text-navy-muted" data-id="element-142" data-mp="3fuqcbadqzmkr">
            <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-143" data-mp="315u3vc7s47jm" />
            Pago seguro · Recibís el acceso apenas se confirma la compra
          </p>
        </div>
      </div>
    </section>;
}